import moment from 'moment';
import React from 'react';

const TableSection = (props) => {
    return (
        <>
            <div class="item-listing">
                <div className="hidden print-title print:flex print:justify-between print:items-center">
                    <h4>GST Sales Register Report</h4>
                </div>
                <div class="itemList-table print:w-full">
                    <div class="table-container print:w-full print:!h-full print:!overflow-hidden"
                        style={{ height: "calc(100vh - 298px)" }}
                    >
                        {props.filterDetails.search === "invoiceDetails" ?
                            <table class="itemList">
                                <thead>
                                    <tr>
                                        <td className='w-[7%] print-w-6'>Inv. No</td>
                                        <td className='w-[9%] print-w-10'>Inv. Date</td>
                                        <td className='w-[12%] print-w-19'>Party Name</td>
                                        <td className='w-[3%] print-w-3'>Disc.</td>
                                        <td className='w-[8%] print-w-6'>Txbl. Amt.</td>
                                        <td className='w-[4%] print-w-4'>SG %</td>
                                        <td className='w-[7%] print-w-6'>SG Amt.</td>
                                        <td className='w-[4%] print-w-4'>CG %</td>
                                        <td className='w-[7%] print-w-6'>CG Amt.</td>
                                        <td className='w-[4%] print-w-4'>IG %</td>
                                        <td className='w-[7%] print-w-6'>IG Amt.</td>
                                        <td className='w-[8%] print-w-6'>{props.pageName === "gstSales" ? "Sales Amt." : "Pur. Amt."}</td>
                                        <td className='w-[4%] print-w-4'>Freight</td>
                                        <td className='w-[4%] print-w-4'>Other</td>
                                        <td className='w-[5%] print-w-5'>Rnd O.</td>
                                        <td className='w-[10%] print-w-10'>Net Amt.</td>
                                    </tr>
                                </thead>
                                <tbody className="print:!text-[12px] print:text-black">
                                    {props.gstSalesRegisterList && props.gstSalesRegisterList.length > 0 ? (
                                        props.gstSalesRegisterList.map((details, key) => (
                                            <tr key={key} className="hover:bg-gray-200">
                                                <td>{details.invoiceNo}</td>
                                                <td>{moment(details.invoiceDate).format('DD MMM yyyy')}</td>
                                                <td>{details.partyId.partyName}</td>
                                                <td>{details.discount ? details.discount : 0}</td>
                                                <td>{details.subTotal}</td>
                                                <td>{details.sgstRate.toFixed(2)}%</td>
                                                <td>{details.sgst}</td>
                                                <td>{details.cgstRate.toFixed(2)}%</td>
                                                <td>{details.cgst}</td>
                                                <td>{details.igstRate.toFixed(2)}%</td>
                                                <td>{details.igst}</td>
                                                <td>{details.grandTotal - Number(details.freight ? details.freight : 0) - Number(details.other ? details.other : 0)}</td>
                                                <td>{details.freight ? details.freight : 0}</td>
                                                <td>{details.other ? details.other : 0}</td>
                                                <td>{details.roundOff}</td>
                                                <td>{details.grandTotal}</td>
                                            </tr>
                                        ))
                                    ) : props.gstSalesRegisterList &&
                                        props.gstSalesRegisterList.length === 0
                                        && props.tableStatus !== "" ? (
                                        <tr>
                                            <td colSpan={16} style={{ textAlign: "center", fontSize: "16px" }}>
                                                {props.tableStatus}
                                            </td>
                                        </tr>
                                    ) : props.gstSalesRegisterList &&
                                        props.gstSalesRegisterList.length === 0
                                        && props.tableStatus === "" ? null : ""}
                                </tbody>
                            </table>

                            : props.filterDetails.search === "salesPurchseSummary" ?
                                <table class="itemList">
                                    <thead>
                                        <tr>
                                            <td className='w-[70%]'>Description</td>
                                            <td className='w-[30%]'>Amount</td>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        {props.gstSalesSummaryList
                                            && props.gstSalesSummaryList.length > 0 ? (
                                            props.gstSalesSummaryList.map((details, key) => (
                                                <tr
                                                    key={key}
                                                    className="hover:bg-gray-200"
                                                >
                                                    <td>{details.des}</td>
                                                    <td>{details.amount.toFixed(2)}</td>
                                                </tr>
                                            ))
                                        ) : props.gstSalesSummaryList &&
                                            props.gstSalesSummaryList.length === 0
                                            && props.tableStatus !== "" ? (
                                            <tr>
                                                <td colSpan={2} style={{ textAlign: "center", fontSize: "16px" }}>
                                                    {props.tableStatus}
                                                </td>
                                            </tr>
                                        ) : props.gstSalesSummaryList &&
                                            props.gstSalesSummaryList.length === 0
                                            && props.tableStatus === "" ? null : ""}
                                    </tbody>
                                </table>

                                : props.filterDetails.search === "gstSummary" ?
                                    <table class="itemList">
                                        <thead>
                                            <tr>
                                                <td className='w-[15%]'>Rate</td>
                                                <td className='w-[25%]'>Taxtable Amount</td>
                                                <td className='w-[20%]'>SGST Amount</td>
                                                <td className='w-[20%]'>CGST Amount</td>
                                                <td className='w-[20%]'>IGST Amount</td>


                                            </tr>
                                        </thead>
                                        <tbody>
                                            {props.gstSummaryList
                                                && props.gstSummaryList.length > 0 ? (
                                                props.gstSummaryList.map((details, key) => (
                                                    <tr
                                                        key={key}
                                                    >
                                                        <td>{(Number(details.rate)).toFixed(2)}</td>
                                                        <td>{(details.taxableAmount).toFixed(2)}</td>
                                                        <td>{(details.sgstAmount).toFixed(2)}</td>
                                                        <td>{(details.cgstAmount).toFixed(2)}</td>
                                                        <td>{(details.igstAmount).toFixed(2)}</td>
                                                    </tr>
                                                ))
                                            ) : props.gstSummaryList &&
                                                props.gstSummaryList.length === 0
                                                && props.tableStatus !== "" ? (
                                                <tr>
                                                    <td colSpan={5} style={{ textAlign: "center", fontSize: "16px" }}>
                                                        {props.tableStatus}
                                                    </td>
                                                </tr>
                                            ) : props.gstSummaryList &&
                                                props.gstSummaryList.length === 0
                                                && props.tableStatus === "" ? null : ""}
                                        </tbody>
                                    </table>
                                    : null}

                    </div>
                </div>
            </div>

            {/*----- Print layout -----*/}
            <div className='table-print mt-5 hidden' id="printableArea">
                {/* Header */}
                <div className="print-header">
                    <table className="hdr-table">
                        <tbody>
                            <tr>
                                <td>
                                    <div className="co-name">{props.companyName}</div>
                                    <div className="rpt-sub">GST Sales Register</div>
                                </td>
                                <td>
                                    <div className="hdr-meta">
                                        Start Date: <strong>{props.filterDetails.startDate}</strong><br />
                                        End Date: <strong>{props.filterDetails.endDate}</strong>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>

                    <div className="rule-thick" />
                    <div className="rule-thin" />
                </div>


                <div className="print-content">

                    {/* <div className="info-row">
                                                  <div>
                                                    <span className="info-label">Item Name:</span>
                                                    <p className="info-value">Paracetamol</p>
                                                  </div>
                                                </div> */}

                    {/* Table */}
                    <table className="data-tbl">
                        <colgroup>
                            <col style={{ width: "5%" }} />
                            <col style={{ width: "7%" }} />
                            <col style={{ width: "10%" }} />
                            <col style={{ width: "6%" }} />
                            <col style={{ width: "7%" }} />
                            <col style={{ width: "4%" }} />
                            <col style={{ width: "7%" }} />
                            <col style={{ width: "4%" }} />
                            <col style={{ width: "7%" }} />
                            <col style={{ width: "4%" }} />
                            <col style={{ width: "7%" }} />
                            <col style={{ width: "7.5%" }} />
                            <col style={{ width: "5.5%" }} />
                            <col style={{ width: "5.5%" }} />
                            <col style={{ width: "5.5%" }} />
                            <col style={{ width: "8%" }} />
                        </colgroup>

                        <thead>
                            <tr>
                                <th style={{ textAlign: 'left' }}>
                                    Inv. No
                                </th>
                                <th style={{ textAlign: 'left' }}>
                                    Inv. Date
                                </th>
                                <th style={{ textAlign: 'left' }}>
                                    Party Name
                                </th>
                                <th style={{ textAlign: 'center' }}>
                                    Disc.
                                </th>
                                <th style={{ textAlign: 'center' }}>
                                    Txbl Amt.
                                </th>
                                <th style={{ textAlign: 'center' }}>
                                    SGST (%)
                                </th>
                                <th style={{ textAlign: 'center' }}>
                                    SGST Amt.
                                </th>
                                <th style={{ textAlign: 'center' }}>
                                    CGST (%)
                                </th>
                                <th style={{ textAlign: 'center' }}>
                                    CGST Amt.
                                </th>
                                <th style={{ textAlign: 'center' }}>
                                    IGST (%)
                                </th>
                                <th style={{ textAlign: 'center' }}>
                                    IGST Amt.
                                </th>
                                <th style={{ textAlign: 'center' }}>
                                    {props.pageName === "gstSales" ? "Sales Amt." : "Pur. Amt."}
                                </th>
                                <th style={{ textAlign: 'center' }}>
                                    Freight
                                </th>
                                <th style={{ textAlign: 'center' }}>
                                    Other
                                </th>
                                <th style={{ textAlign: 'center' }}>
                                    Round Off
                                </th>
                                <th style={{ textAlign: 'center' }}>
                                    Net Amt.
                                </th>
                            </tr>
                        </thead>

                        <tbody>
                            {props.gstSalesRegisterList && props.gstSalesRegisterList.length > 0 ?
                                props.gstSalesRegisterList.map((details, key) => (
                                    <tr key={key}>
                                        <td style={{ textAlign: 'left' }}>
                                            {details.invoiceNo}
                                        </td>
                                        <td style={{ textAlign: 'left' }}>
                                            {moment(details.invoiceDate).format('DD MMM yyyy')}
                                        </td>
                                        <td style={{ textAlign: 'left' }}>
                                            {details.partyId.partyName}
                                        </td>
                                        <td style={{ textAlign: 'center' }}>
                                            {details.discount ? details.discount : 0}
                                        </td>
                                        <td style={{ textAlign: 'center' }}>
                                            {details.subTotal}
                                        </td>
                                        <td style={{ textAlign: 'center' }}>
                                            {details.sgstRate.toFixed(2)}%
                                        </td>
                                        <td style={{ textAlign: 'center' }}>
                                            {details.sgst}
                                        </td>
                                        <td style={{ textAlign: 'center' }}>
                                            {details.cgstRate.toFixed(2)}%
                                        </td>
                                        <td style={{ textAlign: 'center' }}>
                                            {details.cgst}
                                        </td>
                                        <td style={{ textAlign: 'center' }}>
                                            {details.igstRate.toFixed(2)}%
                                        </td>
                                        <td style={{ textAlign: 'center' }}>
                                            {details.igst}
                                        </td>
                                        <td style={{ textAlign: 'center' }}>
                                            {details.grandTotal - Number(details.freight ? details.freight : 0) - Number(details.other ? details.other : 0)}
                                        </td>
                                        <td style={{ textAlign: 'center' }}>
                                            {details.freight ? details.freight : 0}
                                        </td>
                                        <td style={{ textAlign: 'center' }}>
                                            {details.other ? details.other : 0}
                                        </td>
                                        <td style={{ textAlign: 'center' }}>
                                            {details.roundOff}
                                        </td>
                                        <td style={{ textAlign: 'center' }}>
                                            {details.grandTotal}
                                        </td>
                                    </tr>
                                )) : (
                                    <tr>
                                        <td colSpan="16" style={{ textAlign: 'center' }}>
                                            No Data Found
                                        </td>
                                    </tr>
                                )}
                        </tbody>
                        <tfoot>
                            <tr style={{ backgroundColor: '#f5f5f5' }}>
                                <td colSpan="3" style={{ textAlign: 'left', fontWeight: 'bold' }}>
                                    Total
                                </td>
                                <td style={{ textAlign: 'center', fontWeight: 'bold' }}>
                                    {Number(props.filterDetails.discount).toFixed(2)}
                                </td>
                                <td style={{ textAlign: 'center', fontWeight: 'bold' }}>
                                </td>
                                <td style={{ textAlign: 'center', fontWeight: 'bold' }}>
                                </td>
                                <td style={{ textAlign: 'center', fontWeight: 'bold' }}>
                                    {Number(props.filterDetails.sgstAmt).toFixed(2)}
                                </td>
                                <td style={{ textAlign: 'center', fontWeight: 'bold' }}>
                                </td>
                                <td style={{ textAlign: 'center', fontWeight: 'bold' }}>
                                    {Number(props.filterDetails.cgstAmt).toFixed(2)}
                                </td>
                                <td style={{ textAlign: 'center', fontWeight: 'bold' }}>
                                </td>
                                <td style={{ textAlign: 'center', fontWeight: 'bold' }}>
                                    {Number(props.filterDetails.igstAmt).toFixed(2)}
                                </td>
                                <td style={{ textAlign: 'center', fontWeight: 'bold' }}>
                                </td>
                                <td style={{ textAlign: 'center', fontWeight: 'bold' }}>
                                    {props.filterDetails.freight}
                                </td>
                                <td style={{ textAlign: 'center', fontWeight: 'bold' }}>
                                    {Number(props.filterDetails.other).toFixed(2)}
                                </td>
                                <td style={{ textAlign: 'center', fontWeight: 'bold' }}>
                                    {Number(props.filterDetails.roundOff).toFixed(2)}
                                </td>
                                <td style={{ textAlign: 'center', fontWeight: 'bold' }}>
                                    {props.filterDetails.netAmount}
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                </div>

                {/* Footer */}
                <div className="print-footer">
                    <div className="rule-foot">
                        <table className="foot-tbl">
                            <tbody>
                                <tr>
                                    <td>* System generated report. No signature required.</td>
                                    <td style={{ textAlign: "right" }}>
                                        Printed: {new Date().toLocaleDateString("en-GB")} {new Date().toLocaleTimeString("en-GB", { hour: "2-digit", minute: "2-digit" })}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>

            </div>
        </>
    );
};

export default TableSection;